// Window.services is declared in global.d.ts

export async function androidScanQRCode(
  cb: (success: boolean, qrCode: string) => void
) {
  // Use callback naming pattern that matches Window index signature
  const cbName =
    `scanQrCodeCallback_${Math.random().toString(36).slice(2, 9)}` as const;
  window[cbName] = (success: unknown, qrCode: unknown): void => {
    cb(success === true, typeof qrCode === "string" ? qrCode : "");
    delete window[cbName];
  };
  window.services?.scanQrCode(cbName);
}
